import React from 'react'
import './staff-apply-table.scss'
import { getBEMCls } from '@/utils/classname'
import { ColumnsType } from 'antd/lib/table'
import { Row } from '@/components/layout/layout'
import $msg from '@/utils/message'
import { IPagination } from '@/model/types/common'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import { Table } from 'antd'
import { showLayer } from '@/utils/layer'
import EditStaff from '../../staff-list/edit-staff/edit-staff'
import StaffRemakDialog from './remark-dialog'

interface ApplicationRecords {
    id: number
    phone: string
    realname: string
    nickname: string
    avatar: string
    create_time: string
    status: number
    gender: number
    birthday: string
    refuse_reason: string
}

const StaffApplyTable = () => {
    const cls = (...arg: string[]) => getBEMCls('staff-apply-table', ...arg)

    const columns: ColumnsType<ApplicationRecords> = [
        {
            title: '提交时间',
            dataIndex: 'create_time',
            width: 143,
        },
        {
            title: '微信信息',
            key: 'name',
            render: (val, record) => {
                return (
                    <Row data-align-items-center>
                        <img
                            style={{
                                border: `1px solid ${record.gender === 2 ? '#ee5b5b' : '#3c90ff'}`,
                            }}
                            className={cls('avatar')}
                            src={record.avatar}
                            alt=""
                        />
                        <div className={cls('nickname')}>{record.nickname}</div>
                        {/* <div className={cls('realname')}>({record.realname})</div> */}
                    </Row>
                )
            },
        },
        {
            title: '真实姓名',
            width: 233,
            dataIndex: 'realname',
        },
        {
            title: '手机号',
            width: 210,
            dataIndex: 'phone',
        },
        {
            title: '拒绝理由',
            dataIndex: 'refuse_reason',
            render: val => val || '-',
        },
        {
            title: '操作',
            align: 'center',
            width: 120,
            dataIndex: 'status',
            render: (val, record) =>
                [0, 1].includes(val) ? (
                    <div data-color-999 data-font-size-14>
                        {val === 0 ? '已通过' : '已拒绝'}
                    </div>
                ) : (
                    <Row data-width-100p data-center data-font-size-14 data-font-weight-500>
                        <div
                            style={{
                                color: '#FF5959',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                showLayer(
                                    <StaffRemakDialog
                                        staffId={record.id}
                                        nickname={record.nickname}
                                        realname={record.realname}
                                        refresh={requestHandle.refresh}
                                    />,
                                )
                            }}
                        >
                            拒绝
                        </div>
                        <div
                            style={{
                                color: '#14CC9B',
                                cursor: 'pointer',
                                marginLeft: '8px',
                            }}
                            onClick={() => {
                                showLayer(<EditStaff staffId={record.id} isNewStaff refresh={requestHandle.refresh} />)
                            }}
                        >
                            通过
                        </div>
                    </Row>
                ),
        },
    ]

    const requestHandle = useRequest<
        {
            list: ApplicationRecords[]
            pagination: IPagination
        },
        {
            records: ApplicationRecords[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/staff/getstaffapplicationrecords',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.records,
                    pagination: data.pagination,
                }
            },
            onError: e => {
                $msg('error', e.message)
            },
        },
    )

    return (
        <div className="table-container">
            <AutoResizer>
                {({ height }) => {
                    return (
                        <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                            <Table
                                rowKey={record => record.id}
                                loading={requestHandle.loading || requestHandle.loadingMore || void 0}
                                bordered
                                pagination={false}
                                columns={columns}
                                dataSource={requestHandle.data?.list}
                                scroll={{ x: 'max-content', y: height - 50 }}
                            />
                        </WithScrollLoad>
                    )
                }}
            </AutoResizer>
        </div>
    )
}

export default StaffApplyTable
